// Type definitions for assessment progress autosave system

import { Industry, Role, Question, QuestionSet, UploadedDocumentSummary } from './index';

export interface AssessmentProgress {
  version: string; // Schema version for migration handling
  sessionId: string; // Unique session identifier
  userId: string | null; // Clerk user ID (null for anonymous)
  lastSaved: string; // ISO timestamp of last save
  currentStep: 'info' | 'overview' | 'additional-questions' | 'document-upload';
  expiresAt: string; // ISO timestamp (7 days from last save)
  
  data: {
    step1: {
      companyName: string;
      industry: Industry | null;
      role?: Role | null;
      completedAt: string | null;
    };
    
    step2: {
      role: Role | null;
      completedAt: string | null;
    };
    
    step3: {
      questionSet: QuestionSet | null;
      aiQuestions: Question[];
      aiAnswers: Record<string, string>; // { questionId: answer }
      reviewedAt: string | null;
    };
    
    step4: {
      additionalQuestions: Question[];
      additionalAnswers: Record<string, string>;
      questionRegenerations: Record<string, number>; // { questionId: count }
      skippedQuestions: string[]; // questionIds
      progress: {
        answered: number;
        total: number;
      };
      completedAt: string | null;
    };

    step5: {
      documents: UploadedDocumentSummary[];
      lastUploadedAt: string | null;
    };
  };
}

export interface SaveStatus {
  isSaving: boolean;
  lastSaved: Date | null;
  error: string | null;
}

export interface ProgressModalData {
  industry: string;
  role: string;
  currentStep: string;
  lastSaved: Date;
  progress?: {
    answered: number;
    total: number;
  };
}

export const CURRENT_VERSION = '1.0.0';
export const EXPIRATION_DAYS = 7;

export const STORAGE_KEYS = {
  PROGRESS: 'process-optimizer:assessment-progress',
  VERSION: 'process-optimizer:version',
  SESSION_ID: 'process-optimizer:session-id',
} as const;

